import { useEffect, useState } from 'react';

import { logError } from '@/lib/errorLogging';
import { inBrowser } from '@/utils/capabilities';

import { electronApis } from '../electron-api';

export const useAppVersion = () => {
  const [currentVersion, setCurrentVersion] = useState<string | null>(null);

  useEffect(() => {
    if (inBrowser()) return;

    const fetchVersion = async () => {
      try {
        const version = await electronApis.system.getAppVersion();
        setCurrentVersion(version);
      } catch (error) {
        logError(error, 'Failed to fetch version', {
          context: 'Settings',
        });
      }
    };

    fetchVersion();
  }, []);

  return currentVersion;
};
